import styled from 'styled-components';
import {
  StatusApprovalProps,
  StatusMovimentProps,
  StatusNotify
} from '../../common/interfaces';
import { ApprovalStatusColor } from '../../components/enum/approvalStatusEnum';
import { MovimentStatusColor } from '../../components/enum/movimentStatusEnum';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    ActionsCell,
    TextFeldClientSearch,
    SearchCard as SchedulingSearchCard,
} from '../sharedTable.styled';

export const StatusMovimentCell = styled.td<StatusMovimentProps>`
  color: ${({ status }) => MovimentStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;

export const StatusApprovalCell = styled.td<StatusApprovalProps>`
  color: ${({ status }) => ApprovalStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;

export const StatusMyNotify = styled.td<StatusNotify>`
  color: ${({ status }) => (status ? '#34d399' : 'var(--accent-rose)')};
  font-weight: 700;
`;
